// extracted by mini-css-extract-plugin
export default {"promoPlaceholder":"RQXu1","content":"Y9hx8","title":"K8wCP","text":"nvXhe"};